// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-field {
  position: sticky;
  top: 0;
  left: 0;
  background-color: #ffffff;
  z-index: 1; }
  .search-field .sub-header .row {
    margin-right: 12px; }

@media all and (max-width: 500px) {
  .search-field .sub-header {
    flex-direction: column-reverse; }
    .search-field .sub-header .row {
      margin-top: 12px;
      margin-right: 0; } }
`, "",{"version":3,"sources":["webpack://./src/component/search/search.scss"],"names":[],"mappings":"AAAA;EACI,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,UAAU,EAAA;EALd;IASY,kBAAkB,EAAA;;AAK9B;EACI;IAEQ,8BAA8B,EAAA;IAFtC;MAKY,gBAAgB;MAChB,eAAe,EAAA,EAClB","sourcesContent":[".search-field {\n    position: sticky;\n    top: 0;\n    left: 0;\n    background-color: #ffffff;\n    z-index: 1;\n\n    .sub-header {\n        .row {\n            margin-right: 12px;\n        }\n    }\n}\n\n@media all and (max-width: 500px) {\n    .search-field {\n        .sub-header {\n            flex-direction: column-reverse;\n\n            .row {\n                margin-top: 12px;\n                margin-right: 0;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
